import api from "requests/versions/api.config";

const RESOURCE_URL = "/api/contacts";

export const getContacts = (params) => api.get(`${RESOURCE_URL}`, { params });

export const createContact = (params) => api.post(`${RESOURCE_URL}`, params);
